

































import { Component, Vue } from "vue-property-decorator";

@Component<Cutscene>({})
export default class Cutscene extends Vue {
  public clicked() {
    this.$emit("next", this);
  }
  mounted(): void {
    setTimeout((): void => {
      this.$emit("next", this);
    }, 2000);
  }
}
